<template>
  <div
    :class="[
      $style.notificationsWrapperInside,
      {
        [$style.notificationsHeader]: !isNotificationPage,
        [$style.notificationsHeaderShow]: isMenuVisible && !isNotificationPage,
      },
    ]"
  >
    <BitBottomSheetHeader
      v-if="!isNotificationPage && platform.isMobile"
      :title="notificationsComponent.newTitle"
      @close="closeNotificationMenu"
    />

    <div
      :class="[
        $style.notificationsWrapper,
        { [$style.noNotificationsContent]: feedUnreaded.length === 0 && feedReaded.length === 0 },
      ]"
    >
      <h2 v-if="isNotificationPage" :class="$style.notificationsWrapperTitle">
        {{ notificationsComponent.newTitle }}
      </h2>
      <p v-if="!feedUnreaded.length" :class="$style.noNotificationsText">
        {{ notificationsComponent.noNotificationsTitle }}
      </p>
      <div v-if="feedUnreaded.length" :class="$style.notificationsWrapperItems">
        <NotificationsItem
          v-for="notification of feedUnreaded"
          :key="notification.id"
          :notification="notification"
          :is-notification-page="isNotificationPage"
        />
      </div>

      <h2
        v-if="isNotificationPage && feedReaded.length"
        :class="[$style.notificationsWrapperTitle, $style.notificationsWrapperTitleBottom]"
      >
        {{ notificationsComponent.archiveTitle }}
      </h2>
      <div v-if="isNotificationPage" :class="$style.notificationsWrapperItems">
        <NotificationsItem
          v-for="notification of feedReaded"
          :key="notification.id"
          :notification="notification"
          :is-notification-page="isNotificationPage"
        />
      </div>
    </div>
    <div v-if="!isNotificationPage" :class="$style.notificationsBellMenu">
      <NuxtLink :to="notificationsPage" :class="$style.notificationsShowAllLinkText">
        <BitButton
          gtmid="ShowAllNotifications"
          type="secondary"
          is-fluid-width
          @click="closeNotificationsBellMenu"
        >
          <template #prependIcon>
            <img src="/images/common/ico_slider_arrow_right.svg?url_encode" alt="" />
          </template>
          {{ notificationsComponent.showAllNotificationsTitle }}
        </BitButton>
      </NuxtLink>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { BitButton, BitBottomSheetHeader } from '@bit/ui-kit';
import { computed } from 'vue';
import { useStoreNotifications } from '~/stores/abstract/notifications';
import { useStoreRoot } from '~/stores/abstract/root';
import { useStoreMenuStatuses } from '~/stores/client/menuStatuses';
import { useStoreComponents } from '~/stores/strapi/components';
import NotificationsItem from '../notificationsListItem/notificationsListItem.vue';

const props = defineProps({
  skipNotifsLimit: {
    type: Boolean,
    default: false,
  },
  isNotificationPage: {
    type: Boolean,
    default: false,
  },
  isMenuVisible: {
    type: Boolean,
    default: false,
  },
});

const storeNotifications = useStoreNotifications();
const storeComponents = useStoreComponents();
const storeMenuStatuses = useStoreMenuStatuses();
const platform = usePlatform();

const closeNotificationMenu = () => {
  storeMenuStatuses.toggleNotificationsMenu(false);
};

const notificationsPage = computed(() => useStoreRoot().localePath('/notifications'));

const feedUnreaded = computed(() =>
  props.isNotificationPage
    ? storeNotifications.feedUnreaded
    : storeNotifications.feedUnreaded.slice(0, 5)
);

const notificationsComponent = computed(() => storeComponents.notifications);
const feedReaded = computed(() => storeNotifications.feedReaded);
const closeNotificationsBellMenu = () => storeMenuStatuses.toggleNotificationsMenu(false);
</script>

<style lang="scss" module src="./notificationsList.scss"></style>
